export enum TAuthMethod {
  Password = 'pwd',
  Windows = 'windows',
}
